import React from "react";
import {connect} from 'react-redux';
import {retryFetching, clearError} from "../../actions/common/fetchingActions";
import ModalPopup from"../../components/common/ModalPopup";
import {translate} from '../../i18n/translate';

class ErrorModal extends React.Component {
    onRetry = () => {
        if (this.props.retryAction)
            this.props.retry();
        this.props.clearError();
    };

    render() {
        if (!this.props.error)
            return null;
        const message = this.props.error.message ? this.props.error.message : translate("Something went wrong")+".";
        const buttonText = this.props.retryAction ? (this.props.retryAction.label ? this.props.retryAction.label :  "Try Again") : "Close";
        return (
            <ModalPopup
                message={translate(message)}
                middle={{text:translate(buttonText), callback:this.onRetry}}/>
        );
    }
}

const mapStateToProps = (state) => {
    const error = (state.fetching || {}).error;
    return {
        error: error,
        message: error ? error.message : undefined,
        retryAction: error ? error.retryAction : undefined
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        retry: () => {
            dispatch(retryFetching());
        },
        clearError: () => {
            dispatch(clearError());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);


// WEBPACK FOOTER //
// ./src/containers/common/ErrorModal.js